module.exports = __webpack_public_path__ + "img/logo.c3820ab9.png";